// React
import { useEffect } from 'react';
import { Box, Typography } from "@mui/material";
import { ErrorOutline } from '@mui/icons-material';

// Hooks
import { useAppTheme } from '../../../hooks/useAppTheme.js';

function RegisterNotConfirmed({ showError }) {
	const { colors } = useAppTheme();

	useEffect(() => {
		showError('Link falsch oder abgelaufen!');
	}, [showError]);

	return (
		<Box sx={{ 
			width: '100%', 
			mt: 2, 
			display: 'flex', 
			flexDirection: 'column', 
			alignItems: 'center',
			gap: 2,
			p: 3
		}}>
			<ErrorOutline sx={{ fontSize: 48, color: 'error.main' }} />
			<Typography variant="h6" color="error" textAlign="center">
				Ungültiger Einladungslink
			</Typography>
			<Typography variant="body2" sx={{ color: colors.login.input.text }} textAlign="center">
				Der Link ist falsch oder abgelaufen. Bitte kontaktiere deinen Trainer für einen neuen Link.
			</Typography>
		</Box>
	)
}

export default RegisterNotConfirmed;